import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const ThinCross = (props: Props): ReactElement => {
  const { width, height, fill } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 8 8">
      <path
        fill={fill}
        fillRule="nonzero"
        d="M.064.157l.043-.05A.364.364 0 0 1 .57.064l.05.043L4 3.486 7.38.106a.364.364 0 0 1 .463-.042l.05.043c.127.126.14.322.043.463l-.043.05L4.514 4l3.38 3.38c.126.125.14.321.042.463l-.043.05a.364.364 0 0 1-.463.043l-.05-.043L4 4.514.62 7.894a.364.364 0 0 1-.463.042l-.05-.043a.364.364 0 0 1-.043-.463l.043-.05L3.486 4 .106.62A.364.364 0 0 1 .065.158l.043-.05-.043.05z"
      />
    </svg>
  );
};

ThinCross.defaultProps = {
  width: '100%',
  height: '100%',
  fill: '#666',
};

export default ThinCross;
